import { Box, Typography, TextField, Button } from '@mui/material';
import { EMAIL_LABEL } from '../../../constants';
import LoginRegistrationHeader from '../../../components/layout/LoginRegistrationHeader';
import { IEmail } from '../../../constants/types';
import { useFormik } from 'formik';
import useSendOTP from '../../../hooks/queries/useSendOtp';
import { EMAIL_VALIDATION_SCHEMA } from '../../../yup/schemas';
import withBoxStyle from '../../../HOC/layout/withBoxStyle';
import AnnotationIcon from '/images/annotationHeart.svg';
import { useAppSelector } from '../../../redux/hooks';

const InvalidEmailComponent = withBoxStyle(() => {
  const { mobile_number = '', country_code = '' } =
    useAppSelector((state) => state.auth?.constants) || {};
  const { sendOtpRequest, isPending } = useSendOTP();

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: EMAIL_VALIDATION_SCHEMA,
    onSubmit: (data: IEmail) => {
      const { email } = data;
      sendOtpRequest(email);
    },
    validateOnMount: true,
    validateOnChange: true,
  });

  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    touched,
    isValid,
  } = formik;

  return (
    <Box sx={{ p: 3 }} className="d-flex flex-column flex-1">
      <form className="d-flex flex-column flex-1" onSubmit={handleSubmit}>
        <LoginRegistrationHeader />
        <Box pt={5} mb={10}>
          <Typography variant="h4" color="primary" mb={1.5}>
            We don't recognise you
          </Typography>
          <Typography variant="body1">
            It looks like the email you entered is incorrect.
          </Typography>
          <Typography mt={3} variant="body1">
            Please check that it matches the one used for your booking or
            contact Stoneygate Eye Hospital for assistance.
          </Typography>
        </Box>
        <TextField
          name="email"
          label={EMAIL_LABEL}
          fullWidth
          type="email"
          required
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.email && Boolean(errors.email)}
          helperText={touched.email && errors.email}
        />
        <Box
          sx={{
            pt: 7.5,
            mt: 'auto',
            mb: 4.5,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <Box
            sx={{
              bgcolor: '#fff',
              gap: 1,
              p: 2.5,
            }}
            className="d-flex align-items-start rounded-50"
          >
            <Box
              sx={{
                bgcolor: '#D9DAFF',
                color: 'common.white',
                p: 1,
                borderRadius: 2,
              }}
              className="d-flex justify-content-center align-items-center"
            >
              <img src={AnnotationIcon} />
            </Box>
            <Box className="flex-1">
              <Typography variant="body2" sx={{ mb: 1.25 }}>
                Are you experiencing issues with the platform?{' '}
                <Typography
                  component="a"
                  fontWeight="bold"
                  href={`tel:${country_code}${mobile_number}`}
                >
                  Contact us
                </Typography>
              </Typography>
            </Box>
          </Box>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            type="submit"
            disabled={!isValid || isPending}
          >
            Retry
          </Button>
        </Box>
      </form>
    </Box>
  );
});

export default InvalidEmailComponent;
